import React from "react";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Button from "common/components/CustomButtons/Button.jsx";

import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";
import CardActions from "@material-ui/core/CardActions";
import FormLabel from "@material-ui/core/FormLabel";
import TextField from "@material-ui/core/TextField";

import Assignment from "@material-ui/icons/Assignment";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";

import withStyles from "@material-ui/core/styles/withStyles";
import styles from "../styles";

import CardFormComponent from "./components/CardFormComponent";
import PhoneInputComponent from "./components/PhoneInputComponent";

import loadForm from "core-module/hoc/loadForm";
import createRegex from "core-module/tiny-functions/createRegex";

import store from "../../../store";
import { showAlert } from "../../../core-module/services/errorAlert/reducers";

import * as api from "core-module/services/api";

class AccountInfoCardForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      extraRows: 0,
      requestedChange: [
        {
          type: this.props.getSchema().type.dropdownOptions[0][0],
          description: "",
          error: false,
        },
      ],
      comments: "",
      userInfo: this.props.userInfo,
      apiRegex: "",
      bestCallbackNumber: "",
      bestCallbackNumberError: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
  }

  componentDidMount() {
    this.getRegexOptions();
  }

  getUserInfo() {
    return (
      "" +
      this.props.ids.user +
      ", " +
      this.state.userInfo.name +
      ", " +
      this.state.userInfo.name2
    );
  }

  handleSubmit() {
    if (this.shouldPost()) this.postChange();
  }

  shouldPost() {
    if (this.isNotMissingInfo() && !this.checkFormErrors()) return true;
    else return false;
  }

  isNotMissingInfo() {
    let missingInfo = [];
    this.state.requestedChange.forEach((item) =>
      item.description ? null : missingInfo.push(item.type)
    );
    if (this.state.bestCallbackNumber === "") {
      missingInfo.push("Best callback number");
    }

    if (missingInfo.length !== 0) {
      store.dispatch(
        showAlert(this.getErrorMessage("Missing Info", missingInfo))
      );
      return false;
    } else return true;
  }

  getErrorMessage(errorType, errorInfo) {
    switch (errorType) {
      case "Missing Info":
        var missingInfo = "";
        errorInfo.forEach(
          (item) =>
            (missingInfo =
              missingInfo === "" ? item : missingInfo + ", " + item)
        );
        return (
          "Please fill out the '" +
          missingInfo +
          "' field(s) or delete unwanted rows"
        );
      case "Incorrect form":
        var wrongInfo = "";
        errorInfo.forEach(
          (item) =>
            (wrongInfo = wrongInfo === "" ? item : wrongInfo + ", " + item)
        );
        return (
          "Please correct any mistakes in the following field(s): " + wrongInfo
        );
      default:
        return "Please check form";
    }
  }

  checkFormErrors() {
    let formErrors = [];
    this.state.requestedChange.forEach((item) =>
      item.error === true ? formErrors.push(item.type) : null
    );
    if (this.state.bestCallbackNumberError) {
      formErrors.push("best callback number");
    }

    if (formErrors.length !== 0) {
      store.dispatch(
        showAlert(this.getErrorMessage("Incorrect form", formErrors))
      );
      return true;
    } else return false;
  }

  async postChange() {
    const target = "user." + this.props.ids.user + "/accountinfoupdate";
    let requestedChange = JSON.stringify(this.removeErrorStateFromArray());
    try {
      const res = await api.fetchApi(
        `?target=${target}&schema=0`,
        "POST",
        requestedChange
      );
      const resDataArray = JSON.parse(await res.text());

      if (Number(resDataArray.error) === 1) {
        store.dispatch(showAlert(resDataArray.message));
      }
      // store.dispatch(showAlert(resDataArray.message))
      this.props.editMode();
    } catch (e) {
      store.dispatch(showAlert(e.message));
    }
  }

  removeErrorStateFromArray() {
    let newArray = {};

    if (this.state.extraRows === 0) {
      newArray.type = this.state.requestedChange[0].type;
      newArray.description =
        this.state.comments.length !== 0
          ? this.state.requestedChange[0].description +
            " \n Additional Comments: " +
            this.state.comments
          : this.state.requestedChange[0].description;
      newArray.description = this.state.bestCallbackNumber
        ? newArray.description +
          " \n Best callback number: " +
          this.state.bestCallbackNumber
        : newArray.description;
    } else {
      newArray.type = "other";
      let newDescription = "";

      this.state.requestedChange.forEach(
        (item) =>
          (newDescription =
            newDescription + " \n " + item.type + ": " + item.description)
      );

      newDescription = this.state.bestCallbackNumber
        ? newDescription +
          " \n Best callback number: " +
          this.state.bestCallbackNumber
        : newDescription;
      newDescription =
        this.state.comments.length !== 0
          ? newDescription + " \n Additional Comments: " + this.state.comments
          : newDescription;

      newArray.description = newDescription;
    }
    return newArray;
  }

  handleAdd(currentState) {
    let newRow = {
      type: this.props.getSchema().type.dropdownOptions[
        this.state.requestedChange.length
      ][0],
      description: "",
      error: false,
    };

    currentState.push(newRow);

    this.setState({
      extraRows: this.state.extraRows + 1,
      requestedChange: currentState,
    });
  }

  handleDelete(currentState) {
    currentState.pop();

    this.setState({
      extraRows: this.state.extraRows - 1,
      requestedChange: currentState,
    });
  }

  handleExtraInfo(type) {
    let currentState = [...this.state.requestedChange];

    if (type === "Add") this.handleAdd(currentState);
    else if (type === "Del") this.handleDelete(currentState);
    if (this.state.extraRows < 0) this.setState({ extraRows: 0 });
  }

  shouldDisplayAddButton() {
    return this.state.extraRows + 1 <
      this.props.getSchema().type.dropdownOptions.length
      ? true
      : false;
  }

  handleRegexOptions(options) {
    let regexOptions = [];

    Object.keys(options).forEach((key) => {
      regexOptions[key] = {
        errorMessage: options[key].errorMessage,
        regex: createRegex(options[key].regex),
        // name: options[key].name
      };
    });

    this.setState({ apiRegex: regexOptions });
  }

  async getRegexOptions() {
    const target = "user." + this.props.ids.user + "/accountinfoupdate";
    try {
      const res = await api.fetchApi(`?target=${target}&schema=0`, "GET", "");

      const resDataArray = JSON.parse(await res.text());

      if (resDataArray.error === 1) {
        store.dispatch(showAlert("Please try again"));
      } else {
        this.handleRegexOptions(resDataArray.schema.props);
      }
    } catch (e) {
      store.dispatch(showAlert(e.message));
    }
  }

  handleChange(inputType, value, row, isError) {
    let currentState = [...this.state.requestedChange];
    if (inputType === "select") {
      currentState[row] = {
        ...currentState[row],
        type: value,
      };
    } else if (inputType === "txtField") {
      currentState[row] = {
        ...currentState[row],
        description: value,
        error: isError,
      };
    }
    this.setState({ requestedChange: currentState });
  }

  handlePhoneChange(number, error) {
    this.setState({
      bestCallbackNumber: number,
      bestCallbackNumberError: error,
    });
  }

  render() {
    const { classes } = this.props;

    return (
      <Card>
        <CardHeader color="primary" icon>
          <CardIcon color="primary">
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}> Edit Account Info</h4>
        </CardHeader>
        <CardBody>
          <p className={classes.updateInfo}>
            Account info update for contact #{this.getUserInfo()}
          </p>
          {this.state.requestedChange.map((element, key) => (
            <CardFormComponent
              userInfo={this.state.userInfo}
              key={key}
              iteration={key}
              schema={this.props.getSchema()}
              handleChange={this.handleChange}
              apiRegex={this.state.apiRegex}
            />
          ))}

          <GridContainer justify="flex-end">
            <GridItem>
              {this.state.extraRows > 0 ? (
                <DeleteIcon
                  onClick={() => this.handleExtraInfo("Del")}
                  className={classes.deleteIconStyle}
                />
              ) : null}
              {this.shouldDisplayAddButton() ? (
                <AddIcon
                  onClick={() => this.handleExtraInfo("Add")}
                  className={classes.addIconStyle}
                />
              ) : null}
            </GridItem>
          </GridContainer>

          <PhoneInputComponent
            id={"best callback number"}
            handlePhoneChange={this.handlePhoneChange}
            apiRegex={this.state.apiRegex}
            phoneInputText={"Best callback number"}
          />

          <GridContainer className={classes.containerLine}>
            <GridItem xs={6}>
              <FormLabel className={classes.labelHorizontal}>
                Additional Comments
              </FormLabel>
            </GridItem>
            <GridItem xs={6}>
              <TextField
                multiline
                id={"additional comments"}
                label="Optional"
                onChange={(event) => {
                  this.setState({ comments: event.target.value });
                }}
                className={classes.txtField}
              />
            </GridItem>
          </GridContainer>
        </CardBody>
        <CardActions>
          <GridContainer justify="center">
            <GridItem xs={12} sm={6}>
              <Button
                fullWidth
                color="primaryRed"
                onClick={() => this.props.editMode()}
              >
                Cancel
              </Button>
            </GridItem>
            <GridItem xs={12} sm={6}>
              <Button
                fullWidth
                onClick={() => this.handleSubmit()}
                color="primaryLightBlue"
              >
                Submit
              </Button>
            </GridItem>
          </GridContainer>
        </CardActions>
      </Card>
    );
  }
}

export default withStyles(styles)(
  loadForm("user.session/accountinfoupdate", AccountInfoCardForm)
);
